import { Routes } from '@angular/router';
import { CONTROLLING_ROUTES_WITH_PERMISSIONS } from './app.routes';

export default CONTROLLING_ROUTES_WITH_PERMISSIONS satisfies Routes;